import React from 'react';
import getLangTranslation from '../../common/lang-trans';
import SurveyHeader from '../../components/survey/SurveyHeader';

interface iProps {
    flag: number
}

interface iState {}

class Loading extends React.Component<iProps, iState> {
    public render() {
        const langTransEN = getLangTranslation('en');
        const langTransFR = getLangTranslation('fr');

        const textEN = this.props.flag === -1 ? langTransEN.LoadingPleaseWait : langTransEN.UnableToLoading;
        const textFR = this.props.flag === -1 ? langTransFR.LoadingPleaseWait : langTransFR.UnableToLoading;

        return (
            <React.Fragment>
                <SurveyHeader></SurveyHeader>
                <div className="main-row">
                    <p>{ textEN }</p>
                    <p>{ textFR }</p>
                </div>
            </React.Fragment>);
    }
}


export default Loading;